import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: ReviewState = {
    all: [],
    viewing: undefined,
};

const getters: GetterTree<ReviewState, RootState> = {
    all(state: ReviewState): Review[] {
        return state.all;
    },
};

const mutations: MutationTree<ReviewState> = {
    RESET(state: ReviewState) {
        state.all = [];
        state.viewing = undefined;
    },
    UPDATE_MODEL(state: ReviewState, payload: Review) {
        const index = state.all.findIndex((model: Review) => model.id === payload.id);

        if (index === -1) {
            state.all.push(payload);
        } else {
            state.all[index] = payload;
        }
    },
    SET_MODELS(state: ReviewState, payload: Review[]) {
        state.all = payload;
    },
    SET_VIEWING(state: ReviewState, payload: Review) {
        state.viewing = payload;
    },
};


const actions: ActionTree<ReviewState, RootState> = {
    index({ commit, rootState }) {
        return rootState.api.get(`reviews`, { withCredentials: true })
            .then((response: { data: Review }) => {
                commit('SET_MODELS', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    read({ commit, rootState }, payload: { id: number }) {
        return rootState.api.get(`reviews/${payload.id}`, { withCredentials: true })
            .then((response: { data: Review }) => {
                commit('UPDATE_MODEL', response.data);

                commit('SET_VIEWING', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};
